import { Fragment } from "react";

export function PC28Draw({ result }: { result: number[] }) {
  const sum = result.reduce((acc, curr) => acc + curr, 0);
  return (
    <div className="flex items-center gap-1">
      {result.map((item, index) => (
        <Fragment key={index}>
          <div className="flex size-8 items-center justify-center rounded-full border-3 border-primary">
            {item}
          </div>
          {index !== result.length - 1 ? <span>+</span> : <span>=</span>}
        </Fragment>
      ))}
      <div className="flex size-8 items-center justify-center rounded-full border-3 border-yellow-500 text-yellow-500">
        {sum}
      </div>
    </div>
  );
}
